import { apiSlice } from "../../app/api/apiSlice";

export const checkoutApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,

  endpoints: (builder) => ({
    // ============================================================
    // PUBLIC CUSTOMER CHECKOUT
    // ============================================================

    validateCoupon: builder.mutation({
      query: (body) => ({
        url: "/checkout/validate-coupon",
        method: "POST",
        body,
      }),
    }),

    createPaymentIntent: builder.mutation({
      query: (body) => ({
        url: "/checkout/create-intent",
        method: "POST",
        body,
      }),
    }),

    getCheckoutQuote: builder.mutation({
      query: (body) => ({
        url: "/checkout/quote",
        method: "POST",
        body,
      }),
    }),

    // ============================================================
    // CUSTOMER ORDER CONFIRMATION
    // ============================================================

    getCheckoutConfirmation: builder.query({
      query: (checkoutSessionId) => ({
        url: "/orders/checkout-confirmation",
        method: "GET",
        params: { checkoutSessionId },
      }),
      keepUnusedDataFor: 0,
    }),

    // ============================================================
    // GUEST ORDER RECOVERY
    // ============================================================

    requestCheckoutRecovery: builder.mutation({
      query: ({ email, checkoutSessionId }) => ({
        url: "/checkout/recovery/request",
        method: "POST",
        body: {
          email,
          checkoutSessionId,
        },
      }),
    }),

    redeemCheckoutRecovery: builder.mutation({
      query: ({ token }) => ({
        url: "/checkout/recovery/redeem",
        method: "POST",
        body: { token },
      }),
    }),

    // ============================================================
    // PRIVATE ADMIN COUPON MANAGEMENT
    // ============================================================

    adminCreateCoupon: builder.mutation({
      query: (body) => ({
        url: "/checkout/admin/coupons",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Coupon"],
    }),

    adminGetAllCoupons: builder.query({
      query: () => "/checkout/admin/coupons",
      providesTags: ["Coupon"],
    }),

    adminGetActiveCoupons: builder.query({
      query: () => "/checkout/admin/coupons/active",
      providesTags: ["Coupon"],
    }),

    adminDeleteCoupon: builder.mutation({
      query: (id) => ({
        url: `/checkout/admin/coupons/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Coupon"],
    }),

    adminDeactivateCoupon: builder.mutation({
      query: (id) => ({
        url: `/checkout/admin/coupons/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Coupon"],
    }),
  }),
});

export const {
  useValidateCouponMutation,
  useCreatePaymentIntentMutation,
  useGetCheckoutQuoteMutation,

  useGetCheckoutConfirmationQuery,
  useRequestCheckoutRecoveryMutation,
  useRedeemCheckoutRecoveryMutation,

  useAdminCreateCouponMutation,
  useAdminGetAllCouponsQuery,
  useAdminGetActiveCouponsQuery,
  useAdminDeleteCouponMutation,
  useAdminDeactivateCouponMutation,
} = checkoutApiSlice;
